import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportConfig } from '../models/report-config';
import { ReportBuilderChatRequest, ReportBuilderChatResponse } from '../models/report-builder-chat';
import { FamilyAudit } from '../models/family-audit';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  baseUrl = environment.apiEndpoint + '/reports/';
  awsUrl = environment.apiEndpoint + '/aws/';

  constructor(private http: HttpClient) {}

  getFamilyAuditData(bidNumber: string): Observable<FamilyAudit[]> {
    return this.http.get<FamilyAudit[]>(this.baseUrl + 'audit/summary/' + encodeURIComponent(bidNumber));
  }

  AuditReportData(projectId: string, userId: string, filter: string, startDate: Date, endDate: Date): Observable<any> {
    let params: any = {};
    params.projectId = projectId;

    if (projectId) {
      params.projectId = projectId;
    } else {
      params.projectId = '';
    }

    if (userId) {
      params.userId = userId;
    } else {
      params.userId = '';
    }

    if (filter) {
      params.filter = filter;
    } else {
      params.filter = '';
    }
    if (startDate) {
      params.startDate = startDate.toISOString();
    } else {
      params.startDate = '';
    }
    if (endDate) {
      params.endDate = endDate.toISOString();
    } else {
      params.endDate = '';
    }
    return this.http.get<any>(this.baseUrl + 'audit', {params} );
  }

  GetProjectEmailLog(projectId: string) {
    const params = { projectId: projectId };
    return this.http.get<any>(this.baseUrl + 'email', {params});
  }
  GenerateDefiniteEmbedUrl(dashboardKey: string, instanceId: string = "", projectId: string = "") {
    let query = "?";
    if(projectId){
      query += `projectId=${projectId}&`;
    }
    query += `instanceId=${instanceId ?? ''}`;
    return this.http.get(this.baseUrl + 'definiteUrl/' + dashboardKey + query, {responseType: 'text'});
  }

  GenerateQuicksightEmbedURL(dashboardKey: string, instanceId = '', projectId = ''): Observable<string> {
    let params = new HttpParams().set('instanceId', instanceId);
    if (projectId) {
      params = params.set('projectId', projectId);
    }
    return this.http.get(`${this.baseUrl}quicksightUrl/${dashboardKey}`, { params, responseType: 'text' });
  }



  GetQuickSightUrl(): Observable<any> {
    return this.http.get(this.awsUrl + 'url', {responseType: 'text'});
  }

  GetReportConfig(reportId: string): Observable<any> {
    let params: any = {};

    if (reportId) {
      params.reportId = reportId;
    } else {
      params.reportId = '';
    }
    return this.http.get<any>(this.baseUrl + 'reportConfig', {params} );
  }
  GetSavedReportConfigs(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'reportConfigs', {} );
  }
  GetFilterValues(field: string): Observable<string[]> {
    return this.http.get<string[]>(this.baseUrl + 'filterValues', { params: { field } });
  }
  SaveReportConfigs(reportConfig: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'reportConfig', reportConfig);
  }
  GetReportData(reportConfig: any, limit:number = 0): Observable<any> {
    const count = 5;
    // We need to stringify these to send to server
    let data = JSON.parse(JSON.stringify(reportConfig));
    data.columns = JSON.stringify(reportConfig.columns);
    data.filters = JSON.stringify(reportConfig.filters);

    return this.http.post<any>(this.baseUrl + 'getReportData/' + limit, data);
  }
  ExportReportData(reportConfig: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'reportConfig/export', reportConfig);
  }
  DeleteReport(reportId: string): Observable<any> {
    return this.http.delete<any>(this.baseUrl + 'reportConfig/' + reportId);
  }
  SendChatMessage(request: ReportBuilderChatRequest): Observable<ReportBuilderChatResponse> {
    return this.http.post<ReportBuilderChatResponse>(this.baseUrl + 'chat', request);
  }
}
